import React from 'react';

export default function NotFound() {
    return (
        <div className="page-section" id="about">
            <div className="container">
                <div className="col-md-9 col-md-push-3">
                    <h1 className="title"><span>404 - Not Found</span></h1>
                </div>
            </div>
        </div>
    );
}
